/**
 * Настроенный HTTP клиент для Medme Stats API на базе fetch
 *
 * ✅ Автоматически добавляет JWT токен из cookie к каждому запросу
 * ✅ Отмена запросов через AbortSignal
 * ✅ Типизация всех запросов и ответов
 */

import { createApiClient } from "@medme/api-client"
import { createAuthFlow, saveAuthenticationTokens } from "@medme/auth"
import { getAppConfig } from "@/app/config/app-config"
import { customFetch as customOAuthFetch } from "@/shared/api/custom-oauth-client"

export type { BodyType, ErrorType } from "@medme/api-client"

const { refreshAuthTokens } = createAuthFlow(customOAuthFetch)

const apiClient = createApiClient({
	getBaseUrl: () => getAppConfig().apiUrl,
	onUnauthorized: async () => {
		const tokens = await refreshAuthTokens()
		if (!tokens) {
			return false
		}
		saveAuthenticationTokens({
			token: tokens.access_token,
			refreshToken: tokens.refresh_token,
		})
		return true
	},
})

/**
 * HTTP клиент для API запросов (mutator для Orval)
 * Принимает (url, options) как стандартный fetch.
 *
 * Обёртка над apiClient, а не прямой реэкспорт: orval статически парсит
 * этот файл и требует, чтобы экспорт был объявлен функцией с параметрами
 * (по их числу он решает, hook это или нет) — результат вызова фабрики
 * он распознать не может.
 */
export const customFetch = <T>(url: string, options: RequestInit): Promise<T> =>
	apiClient<T>(url, options)

export default customFetch
